import { Component, OnInit } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { faFileContract, faMapPin} from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-eqaro',
  templateUrl: './eqaro.component.html',
  styleUrls: ['./eqaro.component.scss']
})
export class EqaroComponent implements OnInit {

    public latitude: Number;
    public longitude: Number;
    public zoom: Number;
    public faFileAlt = faFileContract;
    public faMapPin = faMapPin;

  constructor(private router: Router, private http : HttpClient) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.latitude = 12.7993637;
    this.longitude = 77.7265857;
    this.zoom = 12;
  }

 
}
